import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API } from '../../App';
import { Card } from '../ui/card';
import { Button } from '../ui/button';
import { toast } from 'sonner';
import { Heart, Gavel, Send } from 'lucide-react';

export default function AdminSinglesNightPanel() {
  const [current, setCurrent] = useState(null);
  const [busy, setBusy] = useState(false);
  const adminKey = () => localStorage.getItem('nightbuzz_admin_key') || '';

  const load = async () => {
    try {
      const res = await axios.get(`${API}/singles-night/current-week`);
      setCurrent(res.data);
    } catch (err) { /* silent */ }
  };

  useEffect(() => { load(); }, []);

  const resolve = async () => {
    setBusy(true);
    try {
      const res = await axios.post(`${API}/singles-night/auto-resolve?admin_key=${encodeURIComponent(adminKey())}`);
      toast.success(`Auction: ${res.data.status} — ${res.data.winner || 'no paid bids'}`);
      load();
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Failed');
    } finally { setBusy(false); }
  };

  const broadcast = async () => {
    setBusy(true);
    try {
      const res = await axios.post(`${API}/singles-night/broadcast?admin_key=${encodeURIComponent(adminKey())}`);
      toast.success(`📣 Notified ${res.data.patrons_notified} patrons about ${res.data.winner}`);
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Failed');
    } finally { setBusy(false); }
  };

  return (
    <Card className="p-4 bg-pink-950/30 border border-pink-500/40">
      <div className="flex items-center gap-2 mb-3">
        <Heart className="w-5 h-5 text-pink-400" fill="currentColor" />
        <h3 className="font-bold text-white">Singles Night Auction — Week of {current?.week_date || '...'}</h3>
      </div>

      {current?.has_winner && current.winning_bar ? (
        <div className="mb-3 p-3 bg-yellow-500/10 border border-yellow-500/40 rounded">
          <p className="text-xs text-yellow-400">🏆 Winner</p>
          <p className="font-bold text-white">{current.winning_bar.name}</p>
        </div>
      ) : (
        <p className="text-sm text-slate-400 mb-3">
          No winner yet. {current?.current_bids || 0} bid(s), highest ${current?.highest_bid || 0}.
        </p>
      )}

      <div className="flex gap-2 flex-wrap">
        <Button data-testid="sn-resolve-btn" onClick={resolve} disabled={busy}
          className="bg-blue-600 hover:bg-blue-500">
          <Gavel className="w-4 h-4 mr-2" /> Resolve Auction
        </Button>
        <Button data-testid="sn-broadcast-btn" onClick={broadcast} disabled={busy || !current?.has_winner}
          className="bg-pink-600 hover:bg-pink-500">
          <Send className="w-4 h-4 mr-2" /> Broadcast to All Patrons (Fri/Sat 8pm)
        </Button>
      </div>
      <p className="text-[10px] text-slate-500 mt-2">
        Resolve = pick highest paid bidder as winner. Broadcast = fire in-app notification to every patron announcing tonight&apos;s venue.
      </p>
    </Card>
  );
}
